import React, { Fragment } from 'react';

const IssueWhatToDo = () => (
  <Fragment>
    <p>
      If you have found damage to the vehicle or an issue with the vehicle
      during your inspection, it is important to report this to us through
      the online{' '}
      <a
        className="faq__panel--link"
        href="http://www.autzu.com/dashboard">
        Dashboard
      </a>. If the issue means the vehicle is unsafe to drive, please
      contact our 24/7 Support Team at{' '}
      <a className="faq__panel--link" href="tel:+18336928898">
        1-833-692-8898
      </a>.
    </p>
  </Fragment>
);

export default IssueWhatToDo;



// WEBPACK FOOTER //
// ./src/components/Static/DriverFaq/IssueWhatToDo.js